export default __webpack_public_path__ + "static/CH_Projects-47798726ab1fe23e5d24874b593e01db.svg";